import React, { useMemo, useState, useEffect, useRef } from "react";
import {
  View,
  Image,
  StyleSheet,
  Text,
  ImageBackground,
  TouchableOpacity,
} from "react-native";
import {
  LobbyTableChip,
  MainUsersLiveFramePng,
  PlayerGold,
  PlayerGrey,
  TableLogo,
  TableLogoFr,
  TableLogoru,
  TableLogoBg,
  TablesContainerPng,
} from "../../../assets";
import { useTranslation } from "react-i18next";
import { useDevice } from "../../../utils/hooks/useDevice";
import { useNavigation, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../../navigator";
import { TableItem } from "../../../store/types";
import { RoomRoute } from "../Middle/RoomTablesSection";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import i18n from "../../../i18n/i18n";
declare global {
  interface Window {
    startGame?: (config: {
      userId: string | number;
      tableId?: string | number;
      width: number;
      height: number;
      ownerId?: string | number;
      tutorial?: boolean;
      isVipRoom?: boolean;
      tableLevel?: number;
      playerName?: string;
      playerAvatarUrl?: string;
      soundEnabled?: boolean;
      translations?: Record<string, any>;
      language?: string;
      drawingBuffer?: boolean;
      payToPlay?: boolean;
      freeToPlay?: boolean;
      payToPlayMinLevel?: number;
      token?: string | null;
      api?: string | undefined;
      eventRunning?: any;
      isEventRunning?: any;
      powerMeter?: any;
      tutorialStartGame?: number;
    }) => void;

    destroyGame?: () => void;
  }
}
interface IProps {
  room: TableItem;
  totalCount: number;
  itemIndex: number;
}

type Nav = NativeStackNavigationProp<RootStackParamList>;

const TABLE_IMAGES: Record<string, any> = {
  green: require("../../../assets/tables/green.png"),
  blue: require("../../../assets/tables/blue.png"),
  red: require("../../../assets/tables/red.png"),
  black: require("../../../assets/tables/black.png"),
  vip: require("../../../assets/tables/vip.png"),
  purple: require("../../../assets/tables/purple.png"),
  vegas: require("../../../assets/tables/vegas.png"),
};

let roomImage = {
  sofia: 1,
  london: 2,
  paris: 3,
  monaco: 4,
  vip: 5,
  macao: 6,
  vegas: 7,
};

// const getTableColorKey = (room: TableItem): string => {
//   switch ((room as any).room_id) {
//     // switch (roomImage) {
//     case 1:
//       return "green";
//     case 2:
//       return "blue";
//     case 3:
//       return "red";
//     case 4:
//       return "black";
//     case 5:
//       return "vip";
//     case 6:
//       return "purple";
//     case 7:
//       return "vegas";
//     default:
//       return "green";
//   }
// };
// const getTableImage = (room: TableItem) => {
//   const key = getTableColorKey(room);
//   return TABLE_IMAGES[key] || TABLE_IMAGES.green;
// };

const getTableColorKeyByRoomName = (roomName?: string): string => {
  if (!roomName) return "green";

  const id = roomImage[roomName.toLowerCase() as keyof typeof roomImage];

  switch (id) {
    case 1:
      return "green";
    case 2:
      return "blue";
    case 3:
      return "red";
    case 4:
      return "black";
    case 5:
      return "vip";
    case 6:
      return "purple";
    case 7:
      return "vegas";
    default:
      return "green";
  }
};
const getTableImage = (roomName?: string) => {
  const key = getTableColorKeyByRoomName(roomName);
  return TABLE_IMAGES[key] || TABLE_IMAGES.green;
};

const getTableLogoByLanguage = () => {
  const currentLang = i18n.language || "en";

  if (currentLang.startsWith("fr")) {
    return TableLogoFr;
  }

  if (currentLang.startsWith("bg")) {
    return TableLogoBg;
  }

  if (currentLang.startsWith("ru")) {
    return TableLogoru;
  }

  return TableLogo;
};

const ROOM_NAME_TRANSLATION_KEYS: Record<string, string> = {
  vip: "T_SITE_VIP",
  sofia: "T_SITE_SOFIA",
  london: "T_SITE_LONDON",
  paris: "T_SITE_PARIS",
  monaco: "T_SITE_MONACO",
  macao: "T_SITE_MACAO",
  vegas: "T_SITE_VEGAS",
};

// interface IProps {
//   startGame: () => void;
// }

function PokerTable({ room, totalCount, itemIndex }: IProps) {
  const { t } = useTranslation();
  const {
    width,
    height,
    isClient,
    isMobile,
    isSm,
    isMd,
    isTablet,
    isLandscape,
    isNative,
  } = useDevice();
  const isDesktop = width >= 980;
  const isPortrait = (isTablet && height >= width) || (isSm && height >= width);
  const { navigate } = useNavigation<Nav>();
  const { params } = useRoute<RoomRoute>();
  const roomName = params.roomSlug;
  const roomDisplayName = ROOM_NAME_TRANSLATION_KEYS[
    roomName?.trim().toLowerCase()
  ]
    ? t(ROOM_NAME_TRANSLATION_KEYS[roomName?.trim().toLowerCase()])
    : roomName;
  const isSmall = isLandscape && width < 980;

  const TABLE_ASPECT = 0.65;

  const isSpecial =
    isDesktop && itemIndex % 3 === 1 && itemIndex + 2 < totalCount;

  const layout = useMemo(() => {
    const desktopWidth = width * 0.27 - 50;
    const mobileWidth = width * 0.8;
    const imageWidth = isDesktop
      ? isSpecial
        ? desktopWidth * 0.95
        : desktopWidth * 0.8
      : // : isTablet
        //   ? (isSpecial ? desktopWidth * 0.8 : desktopWidth * 0.7)
        isSmall
        ? desktopWidth
        : mobileWidth * 0.85;
    console.log(imageWidth);
    // const imageWidth = isSpecial
    //   ? isTablet
    //     ? desktopWidth * 0.8 // special tablet
    //     : desktopWidth * 1.1 // special desktop
    //   : isDesktop
    //     ? desktopWidth * 0.9 // normal desktop
    //     : isTablet
    //       ? desktopWidth * 0.7 // normal tablet
    //       : mobileWidth * 0.85; // normal mobile
    return {
      // containerWidth: isDesktop ? width * 0.4 : width * 0.7,
      // containerHeight: isDesktop ? width * 0.22 : width * 0.54,
      // containerWidth: isDesktop ? desktopWidth : mobileWidth,
      // containerHeight: isDesktop ? desktopWidth * 0.55 : mobileWidth * 0.55,
      containerWidth: imageWidth,
      containerHeight: imageWidth * TABLE_ASPECT,
    };
  }, [isDesktop, width]);

  const baseDesktop = [
    { topPercent: -14, leftPercent: 28 },
    { topPercent: 6, leftPercent: -2 },
    { topPercent: -14, leftPercent: 58 },
    { topPercent: 34, leftPercent: -1 },
    { topPercent: 34, leftPercent: 81 },
    { topPercent: 6, leftPercent: 81 },
    { topPercent: 52, leftPercent: 58 },
    { topPercent: 52, leftPercent: 28 },
  ];

  const baseTablet = [
    { topPercent: -10, leftPercent: 28 },
    { topPercent: 8, leftPercent: 3 },
    { topPercent: -10, leftPercent: 58 },
    { topPercent: 40, leftPercent: 1 },
    { topPercent: 40, leftPercent: 84 },
    { topPercent: 6, leftPercent: 82 },
    { topPercent: 52, leftPercent: 55 },
    { topPercent: 52, leftPercent: 28 },
  ];

  const baseMobile = [
    { topPercent: -18, leftPercent: 28 },
    { topPercent: 2, leftPercent: 0 },
    { topPercent: -18, leftPercent: 58 },
    { topPercent: 34, leftPercent: 0 },
    { topPercent: 34, leftPercent: 78 },
    { topPercent: 2, leftPercent: 78 },
    { topPercent: 50, leftPercent: 55 },
    { topPercent: 50, leftPercent: 28 },
  ];

  const { seats, busyCount } = useMemo(() => {
    const positions = isDesktop
      ? baseDesktop
      : isPortrait
        ? baseTablet
        : baseMobile;

    const occupiedSeats = (room?.seats ?? []).filter(
      (seat) => seat.status !== "EMPTY",
    );
    const busyCount = occupiedSeats.length;

    const occupiedSet = new Set<number>(
      occupiedSeats.map((s) => Number(s.seatNumber)),
    );

    const mapped =
      occupiedSet.size > 0
        ? positions.map((pos, idx) => ({
            ...pos,
            status: occupiedSet.has(idx + 1) ? "busy" : "free",
          }))
        : positions.map((pos, idx) => ({
            ...pos,
            status: idx < busyCount ? "busy" : "free",
          }));

    return { seats: mapped, busyCount };
  }, [layout.containerWidth, room]);

  const SectionOne = useMemo(() => {
    return () => (
      <View
        style={{
          alignItems: "center",
          marginBottom: isDesktop ? 14 : 24,
          // marginBottom: isDesktop ? 4 : 24
        }}
      >
        <TouchableOpacity
          onPress={() =>
            navigate("Game", {
              tableId: room?.id,
              legacyRoomId: room?.legacyRoomId,
              isTournamentRoom: false,
            })
          }
        >
          <Text
            style={[
              styles.roomTitle,
              // { fontSize: isDesktop ? 46 : 30, marginTop: isDesktop ? 4 : 0 },
              { fontSize: isSmall ? 18 : 26, marginTop: 0 },
            ]}
          >
            {roomDisplayName} # {room?.name}
          </Text>
        </TouchableOpacity>
        <ImageBackground
          source={TablesContainerPng}
          style={[styles.tableContainer, { marginBottom: isDesktop ? 30 : 2 }]}
          imageStyle={styles.tableContainerImage}
        >
          <Text
            style={[
              styles.tableText,
              {
                fontSize: isDesktop ? 12 : isSmall ? 12 : 16,
                paddingRight: 6,
                flexShrink: 1,
              },
            ]}
            numberOfLines={1}
            ellipsizeMode="tail"
          >
            {t("T_SITE_ROOM_MIN_SUM")}
          </Text>
          <Image
            source={LobbyTableChip}
            style={{
              width: isDesktop || isSmall ? 12 : 22,
              height: isDesktop || isSmall ? 14 : 22,
              paddingHorizontal: 4,
            }}
            resizeMode="stretch"
          />
          <Text
            style={[
              styles.tableText,
              {
                fontSize: isDesktop || isSmall ? 12 : 16,
                paddingLeft: 4,
                paddingRight: 6,
              },
            ]}
          >
            {room?.minimal_chips}
          </Text>
          {/* <Text style={styles.minSumText}>{room?.entryFee}</Text> */}
        </ImageBackground>
      </View>
    );
  }, [isDesktop, room, navigate]);

  const SectionTwo = useMemo(() => {
    return () => (
      <TouchableOpacity
        onPress={() =>
          navigate("Game", {
            tableId: room?.id,
            legacyRoomId: room?.legacyRoomId,
          })
        }
        style={[
          styles.container,
          { width: layout.containerWidth, height: layout.containerHeight },
        ]}
      >
        <Image
          source={getTableImage(roomName)}
          style={styles.tableImage}
          resizeMode="stretch"
        />
        {/* CENTER LOGO */}
        <Image
          source={getTableLogoByLanguage()}
          style={{
            width: layout.containerWidth,
            height: isMobile
              ? layout.containerHeight - 40
              : layout.containerHeight - 25,
            ...StyleSheet.absoluteFillObject,
            justifyContent: "center",
            alignItems: "center",
          }}
          resizeMode="contain"
        />
        {seats.map((s, index) => {
          const top = Math.round((s.topPercent / 100) * layout.containerHeight);
          const left = Math.round(
            (s.leftPercent / 100) * layout.containerWidth,
          );
          return (
            <Image
              key={index}
              source={s.status === "free" ? PlayerGrey : PlayerGold}
              style={[
                styles.seatIcon,
                {
                  top,
                  left,
                  width:
                    isDesktop && isLandscape
                      ? 54
                      : isPortrait
                        ? 76
                        : isMobile
                          ? 60
                          : isSmall
                            ? 36
                            : 50,
                  height:
                    isDesktop && isLandscape
                      ? 54
                      : isPortrait
                        ? 76
                        : isMobile
                          ? 60
                          : isSmall
                            ? 36
                            : 50,
                  //   width: isDesktop ? 80 : 60,
                  // height: isDesktop ? 80 : 60,
                },
              ]}
              resizeMode="contain"
            />
          );
        })}
      </TouchableOpacity>
    );
  }, [isDesktop, layout, seats]);

  const SectionThree = useMemo(() => {
    return () => (
      <View
        style={[styles.participantsWrap, { marginTop: isDesktop ? -16 : 0 }]}
      >
        <ImageBackground
          source={MainUsersLiveFramePng}
          style={[
            styles.badgeStyle,
            { width: isDesktop ? 66 : 66, height: isDesktop ? 66 : 66 },
            // { width: isDesktop ? 88 : 66, height: isDesktop ? 88 : 66 },
          ]}
          resizeMode="contain"
        >
          <Text
            style={[
              styles.textsStyle,
              // { fontSize: isDesktop ? 18 : 12, marginTop: isDesktop ? 18 : 12 },
              { fontSize: isDesktop ? 12 : 12, marginTop: isDesktop ? 12 : 12 },
            ]}
          >
            {busyCount}/{room?.number_of_seats}
          </Text>
        </ImageBackground>
      </View>
    );
  }, [isDesktop]);
  if (!isClient) return null;

  return (
    <View style={[styles.wrapper, { width: isDesktop ? "80%" : "60%" }]}>
      {/* <View style={[styles.wrapper, { width: isDesktop ? "50%" : "100%" }]}> */}

      <View
        style={{
          // flexDirection: isDesktop ? "row" : "column",
          flexDirection: "column",

          justifyContent: "space-between",
          // alignItems: isDesktop ? "center" : "center",
          alignItems: "center",
        }}
      >
        {/* {isDesktop ? (
          <>
            <View style={styles.desktopLeftCol}>
              <SectionOne />
              <SectionThree />
            </View>
            <View style={styles.desktopRightCol}>
              <SectionTwo />
            </View>
          </>
        ) : ( */}
        <>
          <SectionOne />
          <SectionTwo />
          <SectionThree />
        </>
        {/* )} */}
      </View>
    </View>
  );
}

export default PokerTable;

/* ------------ Styles ------------ */

const styles = StyleSheet.create({
  wrapper: {
    padding: 10,
    borderRadius: 12,
    backgroundColor: "transparent",
    alignSelf: "center",
    margin: "auto",
  },
  container: {
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
  },
  tableImage: {
    width: "100%",
    height: "100%",
  },
  tableLogo: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: [{ translateX: -40 }, { translateY: -40 }],
    width: 80,
    height: 80,
  },
  seatIcon: {
    position: "absolute",
  },
  tableContainer: {
    paddingHorizontal: 18,
    paddingVertical: 4,
    alignSelf: "center",
    flexDirection: "row",
    alignItems: "center",
  },
  tableContainerImage: { resizeMode: "contain" },
  tableText: {
    fontSize: 16,
    color: "#fff",
    paddingRight: 22,
    paddingTop: 6,
    paddingBottom: 10,
    fontWeight: "600",
  },
  minSumText: {
    fontSize: 16,
    color: "#FFD700",
    paddingHorizontal: 6,
    paddingBottom: 10,
    paddingTop: 6,
    fontWeight: "500",
  },
  roomTitle: {
    fontWeight: "bold",
    color: "#fff",
    textShadowColor: "rgba(0, 0, 0, 0.7)",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
    textTransform: "uppercase",
  },
  desktopLeftCol: {
    flex: 1,
    justifyContent: "space-between",
    gap: 4,
  },
  desktopRightCol: {
    marginTop: "10%",
  },
  participantsWrap: { alignItems: "center" },
  badgeStyle: { justifyContent: "center" },
  textsStyle: {
    color: "#ffe593",

    textAlign: "center",
    fontWeight: "700",
  },
});
